import { render } from "./dynamicForm.vue?vue&type=template&id=a689b842&scoped=true&ts=true&lang=pug"
import script from "./dynamicForm.vue?vue&type=script&lang=ts"
export * from "./dynamicForm.vue?vue&type=script&lang=ts"

import "./dynamicForm.vue?vue&type=style&index=0&id=a689b842&lang=scss&scoped=true"

import exportComponent from "/Users/danielwu/Documents/bearathome/bat-project/bat-org-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a689b842"]])

export default __exports__